import React from 'react';
import moment from "moment";
import Link from "../base/Link";
import API from "../base/API";
import Auth from "../auth/Auth";
import Storage from "../base/Storage";
import SorTable from "../base/SorTable";
import DeleteButton from "../base/DeleteButton";
import { translate } from "../base/Translation";

export default class VehicleList extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_vehicles: "/vehicle/fetch/all?limit_from=:from&limit_max=:to&brand=:brand",
			delete_vehicle: "/vehicle/delete/:vehicle"
		});

		this.state = {
			limit_from: 0,
			limit_to: 99999,
			vehicles: [],
			tableData: [],
			tableColumns: [
				{ name: "ecv", display: translate("EČV"), sort: true, width: 14 },
				{ name: "brand", display: translate("Značka"), sort: true, width: 13 },
				{ name: "model", display: translate("Model"), sort: true, width: 13 },
				{ name: "customer", display: translate("Meno a Priezvisko"), sort: true, width: 24 },
				{ name: "city", display: translate("Obec"), sort: true, width: 14 },
				{ name: "date_created", display: translate("Vytvorené"), sort: true, width: 9 },
				{ name: "date_updated", display: translate("Upravené"), sort: true, width: 9 },
				{ name: "options", display: " ", width: 4 }
			]
		};
	}

	convertDataForTable(data) {
		return data.map(function (vehicle) {
			let data = {};
			data.id = vehicle.id;
			data.ecv = <Link to={"/vehicles/edit/" + vehicle.id}>{vehicle.ecv ? vehicle.ecv : "--"}</Link>;
			data.customer = vehicle.driver_name + " " + vehicle.driver_surname;
			data.brand = vehicle.brand_data.name ? vehicle.brand_data.name : "--";
			data.model = vehicle.model;
			data.city = vehicle.driver_city;
			data.date_created = moment(vehicle.created.date).format("D.M.Y");
			data.date_updated = moment(vehicle.updated.date).format("D.M.Y");
			data.options = (
				<div style={{ textAlign: "right" }}>
					<DeleteButton onClick={this.deleteVehicle.bind({ vehicle: vehicle.id, currentComponent: this })} permission="VehicleNew" />
				</div>
			);
			return data;
		}.bind(this));
	}

	fetchData() {
		let brandFilter = Storage.get("brand_filter");

		this.api.request({
			cache: true,
			route: "get_vehicles",
			params: { from: this.state.limit_from, to: this.state.limit_to, brand: (brandFilter ? brandFilter.id : "all") },
			success: (response) => {
				let tableData = this.convertDataForTable(response);
				this.setState({ vehicles: response, tableData });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	deleteVehicle(evt) {
		this.currentComponent.api.request({
			route: "delete_vehicle",
			params: { vehicle: this.vehicle },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	render() {
		return (
			<SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="ecv" title={translate("Vozidlá")} right={() => {
				if (Storage.get("allowed_components").indexOf("VehicleNew") === -1) {
					return "";
				}
				return (
					<Link to="/vehicles/add/new" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
				)
			}} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/vehicle/VehicleList.js